import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { DropIdEnquiry_GETROW } from "../../Server/ApiV2";
import { vRdxUserInfo } from "../../Redux/roStore";
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import { CmpTypographyField } from "../../Component/Common/ToolBox/ToolBox";
import { SummaryCard } from "./Component/SummaryCard";
import { DetailCard } from "./Component/DetailCard";
const initialData = [];
const DropIdEnquiry = () => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState([
//   {L_VocTyp	:"",L_VocTypName:"",	L_VocNo	:"",Party:"",	PartyName:""}
  ]);
  const [dataDetail, setDataDetail] = useState([
    // {ItmCd:"",	ItmName:"",	Qty:""	,SegregatedQty:"",	Difference:""}
  ]);
  const [filter, setFilter] = useState("");

  const handleLoad = async (xFilter = filter) => {
    const Obj = {
        DropID: xFilter,
    };
    let resp = await DropIdEnquiry_GETROW(
      fcheck_null_undefine_replace_empty(Obj)
    );
    if (resp?.status === 200 ) {
      console.log(resp);
      let respData = resp?.data?.ResultSet.Summary;
      let respDataDetail = resp?.data?.ResultSet.Detail;
      setData(respData);
      setDataDetail(respDataDetail);
      setFilter("")
    } else {
      setData([]);
      setDataDetail([]);
      
    }

    setTimeout(async () => {
      document.getElementsByName("SCAN")[0]?.focus();
    }, 100);
    // document.getElementsByName("SCAN")[0]?.focus();
  };
  useEffect(() => {
    handleLoad();
  }, []);

  return (
    // <div sx={{ margin: {md:"40px" ,sm:"5px" , xs:"5px"} }}>
    <div style={{ margin: vMediaQuery ? "1px" : "40px" }}>
      <Grid
        container
        spacing={0.5}
        style={{ margin: "12px 0px", alignItems: "center" }}
      >
        <Grid item xs={8} md={4}>
          <TextField
            fullWidth
            label="SCAN"
            name="SCAN"
            variant="outlined"
            value={filter}
            onChange={(e) => {
              setFilter(e.target.value);
              // handleFilter((e.target.value).toUpperCase());
            }}
            onKeyUp={(e) => {
              if (e.key === "Enter" || e._reactName === "onClick") {
                handleLoad(filter.toUpperCase());
              }
            }}
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0.5,
                borderColor: "#1976d2",
              },
            }}
          />
        </Grid>
        <Grid item xs={"auto"}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => handleLoad(filter.toUpperCase())}
            size="small"
          >
            Load
          </Button>
        </Grid>
      </Grid>
     { data.length > 0 &&<CmpTypographyField xcomponent={"span"} xText={"Head"} />}
      <SummaryCard data={data} onClick={(items) => {}} />
       <br/>
      { dataDetail.length > 0 &&<CmpTypographyField xcomponent={"span"} xText={"Detail"} />}
      <DetailCard data={dataDetail} onClick={(items) => {}} />
    </div>
  );
};

export default DropIdEnquiry;
